import React from 'react'
import { Controller } from 'react-hook-form'
import { Radio } from "@material-tailwind/react";

export default function ARadio({ v }) {

  const onChange = (e)=>{
      console.log(e);
  }
 
  return (
    <>
      {!v?.data?.hide && <div className=''>
      {!v?.data?.isStyle && <p className="text-base text-black text-black-900 font-semibold amiriB">{v?.data?.label}</p>}

        <div className="flex gap-10 flex-row text-lg">
          {v?.data?.options?.map((o, i) => {
            return  <Radio key={i}
              label={o.label}
              labelProps = {
                {  className:"bahijB"}
              }
              
              color="purple"
              value={o.name}
              defaultChecked = {v?.data?.name===o.name?true:false}
             
              {...v?.register(v?.data?.name, { required: v?.data?.required })}

            />  
          })}
        </div>
      </div>
      }

    </>
  );
}